import { getSize } from '@/utils/iterable/getSize';
import { request } from '@/utils/api/request';
import { get } from '@/utils/iterable/get';

import { CHANNEL_ID } from '@/constants/channels';
import { ENDPOINT } from '@/constants/api';

export const schedule = {
  counts: {
    get({ db, shopId, signal }) {
      return request.get({
        endpoint: ENDPOINT.SCHEDULED_UPDATES,
        signal,
        url: `/pending-counters/${db}/${shopId}`,
      });
    },
  },
  listings: {
    delete({ productId, updateId }) {
      return request.delete({
        endpoint: ENDPOINT.SCHEDULED_UPDATES,
        payload: {
          product_id: productId,
          scheduled_update_id: updateId,
        },
        url: '/listings',
      });
    },
    get({ db, shopId, signal, params }) {
      return new Promise(function executor(resolve, reject) {
        request
          .get({
            endpoint: ENDPOINT.SCHEDULED_UPDATES,
            params,
            signal,
            url: `/${db}/${shopId}`,
          })
          .then(
            function onScheduledUpdates(response) {
              if (getSize(response.scheduled_updates) === 0) {
                return resolve(response);
              }

              request
                .get({
                  endpoint: ENDPOINT.SCHEDULED_UPDATES,
                  url: '/listings',
                  params: { scheduled_update_ids: response.scheduled_updates.map(get('id')).join(',') },
                  signal,
                })
                .then(
                  function onScheduledListings(listings) {
                    function mapScheduledUpdates(update) {
                      return { ...update, ...listings[update.id] };
                    }

                    response.scheduled_updates = response.scheduled_updates.map(mapScheduledUpdates);
                    resolve(response);
                  },
                  reject,
                );
            },
            reject
          );
      });
    },
  },
  updates: {
    create({ channel, db, operations, shopId, startDate, type }) {
      return request.post({
        endpoint: ENDPOINT.SCHEDULED_UPDATES,
        payload: {
          userDb: db,
          shopId: parseInt(shopId),
          channelId: CHANNEL_ID[channel],
          operations,
          startDate,
          type,
        },
        url: '',
      });
    },
    delete({ db, shopId, updateId }) {
      return request.delete({
        endpoint: ENDPOINT.SCHEDULED_UPDATES,
        url: `/${db}/${shopId}/${updateId}`,
      });
    },
    get({ db, shopId, signal, params }) {
      return request.get({
        endpoint: ENDPOINT.SCHEDULED_UPDATES,
        params,
        signal,
        url: `/${db}/${shopId}`,
      });
    },
  },
};
